import { DEFAULT_COUNTRY_SELECTED } from "common/constants/countries"
import mapCamposPersonalizados from "common/mappers/mapCamposPersonalizados"
import { contactFormTaxesMapper } from "features/Contactos/constants"

export default (contacto = {}, create: $TSMigrationFixMe) => {
  const direccion =
    // @ts-expect-error TS(2339): Property 'codigoPais' does not exist on type '{}'.
    contacto.codigoPais === DEFAULT_COUNTRY_SELECTED
      ? {
          // @ts-expect-error TS(2339): Property 'direccion' does not exist on type '{}'.
          calle: contacto.direccion,
          // @ts-expect-error TS(2339): Property 'cp' does not exist on type '{}'.
          codigoPostal: contacto.cp,
          // @ts-expect-error TS(2339): Property 'poblacionId' does not exist on type '{}'...
          poblacionId: contacto.poblacionId,
          // @ts-expect-error TS(2339): Property 'poblacion' does not exist on type '{}'.
          poblacionNombre: contacto.poblacion,
        }
      : {
          // @ts-expect-error TS(2339): Property 'direccion' does not exist on type '{}'.
          calle: contacto.direccion,
          // @ts-expect-error TS(2339): Property 'cp' does not exist on type '{}'.
          codigoPostal: contacto.cp,
          // @ts-expect-error TS(2339): Property 'poblacionExtranjera' does not exist on t...
          poblacionExtranjera: contacto.poblacionExtranjera,
        }

  // @ts-expect-error TS(2339): Property 'cuentasBancarias' does not exist on type...
  const mappedCuentasBancarias = contacto.cuentasBancarias?.map(
    (cuenta: $TSMigrationFixMe) => {
      return {
        bic: cuenta?.bank?.bic || cuenta?.bic,
        entidadBancariaId: cuenta?.bank?.code || cuenta?.entidadBancariaId,
        iban: cuenta?.iban,
        principal: cuenta?.principal,
        id: !cuenta.isNew ? cuenta?.id : null,
      }
    }
  )

  const createPayload = {
    // @ts-expect-error TS(2339): Property 'razonSocial' does not exist on type '{}'...
    razonSocial: contacto.razonSocial,
    // @ts-expect-error TS(2339): Property 'cif' does not exist on type '{}'.
    nif: contacto.cif,
    // @ts-expect-error TS(2339): Property 'codigoPais' does not exist on type '{}'.
    codigoPais: contacto.codigoPais,
    direccion,
    // @ts-expect-error TS(2339): Property 'email' does not exist on type '{}'.
    email: contacto.email,
    // @ts-expect-error TS(2339): Property 'telefono' does not exist on type '{}'.
    telefono: contacto.telefono,
  }

  return {
    ...createPayload,
    ...(!create && {
      // @ts-expect-error TS(2339): Property 'id' does not exist on type '{}'.
      id: contacto.id,
      // @ts-expect-error TS(2339): Property 'cuentaContableId' does not exist on type...
      cuentaContableEmpresaId: contacto.cuentaContableId,
      camposPersonalizados: mapCamposPersonalizados(
        // @ts-expect-error TS(2339): Property 'camposPersonalizados' does not exist on ...
        contacto.camposPersonalizados
      ),
      contactoConfiguracion: {
        // @ts-expect-error TS(2339): Property 'contactoConfiguracion' does not exist on...
        formaPago: contacto.contactoConfiguracion.formaPago,
        // @ts-expect-error TS(2339): Property 'vencimientoDias' does not exist on type ...
        vencimientoDias: contacto.vencimientoDias,
        // @ts-expect-error TS(2339): Property 'descuento' does not exist on type '{}'.
        descuento: contacto.descuento,
        // @ts-expect-error TS(2339): Property 'diaDePago' does not exist on type '{}'.
        diaDePago: contacto.diaDePago,
        // @ts-expect-error TS(2339): Property 'referencia' does not exist on type '{}'.
        referencia: contacto.referencia,
        // @ts-expect-error TS(2339): Property 'delegacion' does not exist on type '{}'.
        delegacion: contacto.delegacion,
      },
      cuentasBancarias: mappedCuentasBancarias,
      // @ts-expect-error TS(2339): Property 'cuentaContableClienteId' does not exist ...
      cuentaContableClienteId: contacto.cuentaContableClienteId,
      // @ts-expect-error TS(2339): Property 'cuentaContableProveedorId' does not exis...
      cuentaContableProveedorId: contacto.cuentaContableProveedorId,
      // @ts-expect-error TS(2339): Property 'cuentaContableVentaId' does not exist on...
      cuentaContableVentaId: contacto.cuentaContableVentaId,
      // @ts-expect-error TS(2339): Property 'cuentaContableCompraId' does not exist o...
      cuentaContableCompraId: contacto.cuentaContableCompraId,
      // @ts-expect-error TS(2339): Property 'etiquetas' does not exist on type '{}'.
      etiquetas: contacto.etiquetas,
      email: null,
      telefono: null,
      ...contactFormTaxesMapper(contacto, [], true),
    }),
  }
}
